import React from "react";

import {
    ButtonLink,
    Container, 
    FilterBarTasksLeft,
    FilterBarTasksRight,
    ButtonLinkSync,
    ButtonSync,
    ButtonAdd
} from "./style";
import { AiFillAppstore, AiOutlineCheckCircle, AiOutlineClose, AiOutlineCloudUpload, AiOutlineSync } from "react-icons/ai";
import { Panel } from "../../../interfaces/Panel";
import FilterDialog, { FilterFlowProps } from "../../FilterBar/FilterDialog";
import { Flow } from "../../../interfaces/Flow";
import { MdDownloading } from "react-icons/md";
import { FaPlus, FaSyncAlt } from "react-icons/fa";
import getAccessControl from "../../../middlewares/AccessControl";

interface DashboardManagerBarProps {
    typeUser: string;
    flow?: Flow;
    openPagesMenu?: boolean;
    selectedPanel?: Panel;
    filterFlow?: FilterFlowProps;
    loadingPanel?: boolean;
    statusSaved?: number;
    refreshPanel?: () => void;
    onAddElement?: () => void;
    setOpenPagesMenu?: (open: boolean) => void;
    onFilterFlow: (filterFlow: FilterFlowProps, openedDialog: boolean) => void;
}

const DashboardManagerBar: React.FC<DashboardManagerBarProps> = ({ typeUser, flow, openPagesMenu, selectedPanel, filterFlow, loadingPanel, statusSaved, refreshPanel, setOpenPagesMenu, onFilterFlow, onAddElement }) => {

    return (
        <Container>
            <FilterBarTasksLeft>

                {setOpenPagesMenu && (
                    <ButtonLink type="button" onClick={() => setOpenPagesMenu(!openPagesMenu)} active={openPagesMenu}>
                        {!openPagesMenu ?
                            <AiFillAppstore /> :
                            <AiOutlineClose size={14} />
                        }
                        {selectedPanel !== undefined && selectedPanel.name !== "" ?
                            selectedPanel.name :
                            "Páginas"
                        }
                    </ButtonLink>
                )}

                {flow !== undefined && (
                    <FilterDialog
                        flow={flow}
                        selectedValue={filterFlow}
                        typeUser={typeUser}
                        itemNavBar={2}
                        onFilterFlow={onFilterFlow}
                    />
                )}

            </FilterBarTasksLeft>
            <FilterBarTasksRight>
                {loadingPanel ?
                    <ButtonLinkSync>
                        <MdDownloading color={"gray"} />
                        Carregando...
                    </ButtonLinkSync> :
                    statusSaved === 1 ?
                        <ButtonLinkSync>
                            <AiOutlineCheckCircle color={"green"} />
                            Alterações salvas
                        </ButtonLinkSync> :
                        statusSaved === 2 ?
                            <ButtonLinkSync>
                                <AiOutlineCloudUpload />
                                Salvando
                            </ButtonLinkSync> :
                            statusSaved === 3 ?
                                <ButtonLinkSync>
                                    <AiOutlineSync />
                                    Salvando
                                </ButtonLinkSync> :
                                <></>}

                {refreshPanel && (
                    <ButtonSync type="button" onClick={() => refreshPanel()}>
                        <FaSyncAlt />
                    </ButtonSync>
                )}

                {getAccessControl(51, typeUser) && onAddElement ?
                    <ButtonAdd type="button" onClick={onAddElement}>
                        <FaPlus />
                        Adicionar elemento
                    </ButtonAdd>
                    : <></>}
            </FilterBarTasksRight>
        </Container>
    );

}

export default DashboardManagerBar;